import { OpenAPIv3_0, OpenAPIv3_1 } from '@criteria/openapi'
import { Listbox, ListboxLabel, ListboxOption } from '@criteria-labs/react'

type OpenAPI = OpenAPIv3_1<never> | OpenAPIv3_0<never>
type Server = { url: string }

export function ServerPicker({
  openAPI,
  value,
  onChange
}: {
  openAPI: OpenAPI
  value: Server
  onChange: (server: Server) => void
}) {
  const { servers = [] } = openAPI
  if (servers.length === 0) {
    return null
  }

  return (
    <Listbox<Server>
      value={value ?? undefined}
      onChange={onChange}
      defaultValue={servers[0]}
      placeholder="Choose server&;hellip"
    >
      {servers.map((server) => (
        <ListboxOption key={server.url} value={server}>
          <ListboxLabel>{server.url}</ListboxLabel>
        </ListboxOption>
      ))}
    </Listbox>
  )
}
